module.exports = __webpack_public_path__ + "img/03.f7129cf6.jpg";